import React, { useEffect } from 'react';
import Footer from '../Footer/Footer';
import { Outlet } from 'react-router-dom';
import MainNavbar from '../Navbbar/Navbar';
import './Layout.css';

export default function Layout() {
    useEffect(() => { }, []);

    return (
        <>
            <MainNavbar />
            <div className="">
                <Outlet></Outlet>
            </div>
            <Footer />
        </>
    );
}